import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import './InstallerPanelTable.css';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ActionType } from '../../stores/action-types';
import { DataTable } from 'primereact/datatable';
import { DataView } from 'primereact/dataview';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { escapeDataTableCsvValue, excelTextDataTableCsvValue, exportDataTableCsv } from '../../helpers/exportCsv';
import { Toolbar } from 'primereact/toolbar';
import { Tooltip } from 'primereact/tooltip';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { MultiSelect } from 'primereact/multiselect';
import { FilterMatchMode } from 'primereact/api';
import Snackbar from '../../../components/Snackbar/Snackbar';
import { connect } from 'react-redux';
import { getSystemsVeryShort, getSimcards, updateSimcard, closeUpdateSimcardSuccessNotification, closeUpdateSimcardFailNotification, 
         addSimcard, getSimcard, closeCreateSimcardSuccessNotification, closeCreateSimcardFailNotification, deleteSimcard, getRouters } from '../../stores/actions/installerActions';
import { getSystemsNodesShort, getSystemsNodesRoutersShort } from '../../stores/actions/logsActions';
import 'react-quill/dist/quill.snow.css';
import RouterEditDialog from './EditDialogs/RouterEditDialog';
import SimcardEditDialog from './EditDialogs/SimcardEditDialog';
import { headerStyleSuccess, headerStyleFail, emptyHeaderStyle } from '../../helpers/GlobalVariables';

interface SimcardsProps {
    mobileView: boolean;
    dbSimcards: any;
    dbRouters: any;
    currentSimcard: any;
    updateSimcardSuccess: boolean;
    updateSimcardFail: boolean;
    updateSimcardFailMessage: string;
    createSimcardSuccess: boolean;
    createSimcardFail: boolean;
    createSimcardFailMessage: string;
    updateRouterSuccess: boolean;
    updateRouterFail: boolean;
    getSystemsVeryShort: () => void;
    getSystemsNodesShort: () => void;
    getSystemsNodesRoutersShort: () => void;
    getSimcards: () => void;
    getRouters: () => void;
    updateSimcard: (simcard) => void;
    addSimcard: (simcard) => void;
    getSimcard: (simcardId) => void;
    deleteSimcard: (systemId) => void;
    closeUpdateSimcardSuccessNotification: () => void;
    closeUpdateSimcardFailNotification: () => void;
    closeCreateSimcardSuccessNotification: () => void;
    closeCreateSimcardFailNotification: () => void;
}

const Simcards = ({
    mobileView,
    dbSimcards,
    dbRouters,
    currentSimcard,
    getSimcards,
    getRouters,
    getSystemsNodesShort,
    getSystemsNodesRoutersShort,
    getSimcard,
    deleteSimcard,
    updateSimcardSuccess,
    updateSimcardFail,
    updateSimcardFailMessage,
    createSimcardSuccess,
    createSimcardFail,
    createSimcardFailMessage,
    updateRouterSuccess,
    updateRouterFail,
    closeUpdateSimcardSuccessNotification,
    closeUpdateSimcardFailNotification,
    closeCreateSimcardSuccessNotification,
    closeCreateSimcardFailNotification
}: SimcardsProps) => {


    let emptySimcard = {
        ID: null,
        systemId: null,
        systemName: null,
        ip: null,
        telephone: null,
        purpose: 'data',
        iccid: null,
        network: 'other',
        pin: null,
        puk: null,
        owner: 'WISENE',
        notes: null,
        pinDisabled: false,
        imageData: null,
        imageMime: null,
        nodeId: null,
        nodeName: null,
        routerId: null,
        routerSerialNumber: null,
        previousNodeId: null,
        previousRouterId: null,
        previousRouterSerialNumber: null,
        previousNodeName: null,
        previousSystemName: null
    };

    const closeNotificationTimer = useRef(null);
    const dispatch = useDispatch();

    const [simcardDialog, setSimcardDialog] = useState(false);
    const [simcard, setSimcard] = useState(emptySimcard);
    const [deleteSimcardDialog, setDeleteSimcardDialog] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [simcards, setSimcards] = useState(dbSimcards);
    const [editRouterSerialNumber, setEditRouterSerialNumber] = useState(null);
    const [selectedSimcard, setSelectedSimcard] = useState(null);

    // Mobile filter state
    const [mobileFilters, setMobileFilters] = useState({
        systemName: '',
        nodeName: '',
        routerSerialNumber: '',
        ip: '',
        telephone: '',
        purpose: null,
        iccid: '',
        network: null,
        owner: null,
        pinDisabled: null,
    });
    const [mobileSortField, setMobileSortField] = useState('ID');
    const [mobileSortOrder, setMobileSortOrder] = useState<-1 | 1>(-1);
    const [mobileFilterDialog, setMobileFilterDialog] = useState(false);
    const [pendingFilters, setPendingFilters] = useState(mobileFilters);
    const [pendingSortField, setPendingSortField] = useState(mobileSortField);
    const [pendingSortOrder, setPendingSortOrder] = useState<-1 | 1>(mobileSortOrder);

    const closeNotification = useCallback(() => {
        dispatch({ type: ActionType.CLOSE_UPDATE_ROUTER_SUCCESS_NOTIFICATION });
        dispatch({ type: ActionType.CLOSE_UPDATE_ROUTER_FAIL_NOTIFICATION });
    }, [dispatch]);
    
    const openMobileFilterDialog = () => {
        setPendingFilters(mobileFilters);
        setPendingSortField(mobileSortField);
        setPendingSortOrder(mobileSortOrder);
        setMobileFilterDialog(true);
    };

    const applyMobileFilters = () => {
        setMobileFilters(pendingFilters);
        setMobileSortField(pendingSortField);
        setMobileSortOrder(pendingSortOrder);
        setMobileFilterDialog(false);
    };

    const resetMobileFilters = () => {
        const empty = {
            systemName: '', nodeName: '', routerSerialNumber: '', ip: '', telephone: '',
            purpose: null, iccid: '', network: null, owner: null, pinDisabled: null,
        };
        setPendingFilters(empty);
        setPendingSortField('ID');
        setPendingSortOrder(-1);
    };

    // Filtered + sorted list
    const filteredSimcards = useMemo(() => {
        if (!simcards) return [];
        let result = [...simcards];

        if (mobileFilters.systemName)
            result = result.filter(s => s.systemName?.toLowerCase().includes(mobileFilters.systemName.toLowerCase()));
        if (mobileFilters.nodeName)
            result = result.filter(s => s.nodeName?.toLowerCase().includes(mobileFilters.nodeName.toLowerCase()));
        if (mobileFilters.routerSerialNumber)
            result = result.filter(s => s.routerSerialNumber?.toLowerCase().includes(mobileFilters.routerSerialNumber.toLowerCase()));
        if (mobileFilters.ip)
            result = result.filter(s => s.ip?.toLowerCase().includes(mobileFilters.ip.toLowerCase()));
        if (mobileFilters.telephone)
            result = result.filter(s => s.telephone?.toLowerCase().includes(mobileFilters.telephone.toLowerCase()));
        if (mobileFilters.purpose)
            result = result.filter(s => s.purpose === mobileFilters.purpose);
        if (mobileFilters.iccid)
            result = result.filter(s => s.iccid?.toLowerCase().includes(mobileFilters.iccid.toLowerCase()));
        if (mobileFilters.network?.length)
            result = result.filter(s => mobileFilters.network.includes(s.network));
        if (mobileFilters.owner)
            result = result.filter(s => s.owner === mobileFilters.owner);
        if (mobileFilters.pinDisabled !== null)
            result = result.filter(s => s.pinDisabled === mobileFilters.pinDisabled);

        result.sort((a, b) => {
            const aVal = a[mobileSortField] ?? '';
            const bVal = b[mobileSortField] ?? '';
            if (aVal < bVal) return -1 * mobileSortOrder;
            if (aVal > bVal) return 1 * mobileSortOrder;
            return 0;
        });

        return result;
    }, [simcards, mobileFilters, mobileSortField, mobileSortOrder]);

    // Badge count
    const activeFilterCount = useMemo(() => {
        return Object.entries(mobileFilters).filter(([key, v]) => {
            if (key === 'systemName') return false; // always-visible, don't count
            if (Array.isArray(v)) return v.length > 0;
            return v !== '' && v !== null;
        }).length;
    }, [mobileFilters]);

    const sortOptions = [
        { label: 'ID', value: 'ID' },
        { label: 'System', value: 'systemName' },
        { label: 'Node name', value: 'nodeName' },
        { label: 'Router', value: 'routerSerialNumber' },
        { label: 'IP', value: 'ip' },
        { label: 'Telephone', value: 'telephone' },
        { label: 'Purpose', value: 'purpose' },
        { label: 'ICCID', value: 'iccid' },
        { label: 'Network', value: 'network' },
        { label: 'PIN', value: 'pin' },
        { label: 'Owner', value: 'owner' },
        { label: 'Notes', value: 'notes' },
        { label: 'PIN Disabled', value: 'pinDisabled' },
    ];

    const networkColors = {
        'Orange': 'bg-orange-500 text-white',
        'T-Mobile': 'bg-pink-500 text-white',
        'Plus': 'bg-emerald-500 text-white',
        'other': 'bg-gray-400 text-black'
    };


    const selectedRouterForEdit = useMemo(() =>
        dbRouters?.find(r => r.serialNumber === editRouterSerialNumber) ?? null,
    [editRouterSerialNumber, dbRouters]);

    const enumFields = ["owner", "purpose"];

    const createFilters = () => {
        let base = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            systemName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            nodeName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            routerSerialNumber: { value: null, matchMode: FilterMatchMode.CONTAINS },
            ip: { value: null, matchMode: FilterMatchMode.CONTAINS },
            telephone: { value: null, matchMode: FilterMatchMode.CONTAINS },
            iccid: { value: null, matchMode: FilterMatchMode.CONTAINS },
            network: { value: null, matchMode: FilterMatchMode.IN },
        };

        enumFields.forEach(field => {
            base[field] = { value: null, matchMode: FilterMatchMode.EQUALS };
        });

        return base;
    };

    const [filters, setFilters] = useState(createFilters());

    const openNew = () => {
        setSelectedSimcard(null);
        setSimcardDialog(true);
    };

    const editSimcard = (simcard) => {
        setSelectedSimcard(simcard);
        setSimcardDialog(true);
    };

    const cleanNotes = (html) => {
        if (!html) return '';
        let text = html.replace(/<span class="ql-cursor">.*?<\/span>/g, '');
        text = text.replace(/<\/?[^>]+(>|$)/g, '');
        text = text.replace(/\s+/g, ' ').trim();
        return text;
    };

    useEffect(() => {
        closeNotification();
        getSystemsNodesShort();
        getSystemsNodesRoutersShort();
        getSimcards();
        getRouters();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (dbSimcards) {
            setSimcards(dbSimcards);
        }

    }, [dbSimcards]);

    useEffect(() => {
        if (updateRouterFail || updateRouterSuccess) {
            clearTimeout(closeNotificationTimer.current);
            closeNotificationTimer.current = setTimeout(closeNotification, 6000);
        }
        return () => clearTimeout(closeNotificationTimer.current);
    }, [updateRouterFail, updateRouterSuccess, closeNotification]);

    useEffect(() => {
        if (updateRouterSuccess) {
            getSimcards();
        }
    }, [updateRouterSuccess]);


    useEffect(() => {
        if (updateSimcardSuccess) {
            setTimeout(() => {
                closeUpdateSimcardSuccessNotification();
            }, 6000);
            setSimcardDialog(false);
        }
    }, [updateSimcardSuccess]);

    useEffect(() => {
        if (updateSimcardFail) {
            setTimeout(() => {
                closeUpdateSimcardFailNotification();
            }, 6000)
        }
    }, [updateSimcardFail]);


    useEffect(() => {
        if (createSimcardSuccess) {
            setTimeout(() => {
                closeCreateSimcardSuccessNotification();
            }, 6000);
            setSimcardDialog(false);
        }
    }, [createSimcardSuccess]);

    useEffect(() => {
        if (createSimcardFail) {
            setTimeout(() => {
                closeCreateSimcardFailNotification();
            }, 6000)
        }
    }, [createSimcardFail]);

    useEffect(() => {
        if (currentSimcard) {
            let _simcard = { ...simcard };
            _simcard.imageData = currentSimcard.imageData;
            _simcard.imageMime = currentSimcard.imageMime;
            _simcard.previousNodeId = _simcard.nodeId;
            _simcard.previousRouterId = _simcard.routerId;
            _simcard.previousRouterSerialNumber = _simcard.routerSerialNumber;
            _simcard.previousNodeName = _simcard.nodeName;
            _simcard.previousSystemName = _simcard.systemName;
            setSimcard(_simcard);
        }
    }, [currentSimcard]);
    const dt = useRef(null);

    useEffect(() => {
        if (simcardDialog && simcard.ID) {
            getSimcard(simcard.ID);
        }
    }, [simcardDialog, simcard.ID]);

    const networks = ['Orange', 'T-Mobile', 'Plus', 'other'];
    const owners = ['customer', 'WISENE'];
    const purposes = ['data', 'SMS'];

    const enumFilter = (field, options) => (
        <Dropdown
            value={filters[field]?.value}
            options={options}
            onChange={(e) =>
            setFilters((prev) => ({
                ...prev,
                [field]: { value: e.value, matchMode: FilterMatchMode.EQUALS },
            }))
            }
            placeholder={'-'}
            showClear
            className="w-full"
        />
    );

    const hideDeleteSimcardDialog = () => {
        setDeleteSimcardDialog(false);
    };

    const confirmDeleteSimcard = (simcard) => {
        setSimcard(simcard);
        setDeleteSimcardDialog(true);
    };

    const deleteSimcardItem = () => {
        deleteSimcard(simcard.ID);
        let _simcards = simcards.filter((val) => val.ID !== simcard.ID);
        setSimcards(_simcards);
        setDeleteSimcardDialog(false);
        setSimcard(emptySimcard);
    };

    const deletedNodeWarningIcon = (rowData) => {
        if (!rowData.nodeDeleted) return null;
        const tooltipId = `nodeDeletedWarning-${rowData.ID}`;
        return (
            <>
                <Tooltip target={`#${tooltipId}`} />
                <i
                    id={tooltipId}
                    className="pi pi-exclamation-triangle"
                    style={{ color: '#c55', marginLeft: '0.4rem', flexShrink: 0 }}
                    data-pr-tooltip="Node or System is deleted"
                    data-pr-position="top"
                />
            </>
        );
    };

    const systemNameTemplate = (rowData) => {
        if (rowData.systemId) {
            const tooltipId = `systemName-${rowData.ID}`;
            return (
                <span style={{ display: 'inline-flex', alignItems: 'center', maxWidth: '100%' }}>
                    <Tooltip target={`#${tooltipId}`} />
                    <span
                        id={tooltipId}
                        className="systemName-nodeName"
                        data-pr-tooltip={rowData.systemName}
                        style={{
                            display: 'inline-block',
                            maxWidth: '90%',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {rowData.systemName}
                    </span>
                    {deletedNodeWarningIcon(rowData)}
                </span>
            );
        }
        return null;
    };

    const nodeNameTemplate = (rowData) => {
        if (rowData.nodeId) {
            const tooltipId = `nodeName-${rowData.ID}`;
            return (
                <span style={{ display: 'inline-flex', alignItems: 'center', maxWidth: '100%' }}>
                    <Tooltip target={`#${tooltipId}`} />
                    <span
                        id={tooltipId}
                        className="systemName-nodeName"
                        data-pr-tooltip={rowData.nodeName}
                        style={{
                            display: 'inline-block',
                            maxWidth: '90%',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {rowData.nodeName}
                    </span>
                    {deletedNodeWarningIcon(rowData)}
                </span>
            );
        }
        return null;
    };

    const networkTemplate = (rowData) => {
        if (rowData.network) {
            const tooltipId = `type-row-${rowData.ID}`;
            const networkColors = {
                'Orange': 'bg-orange-500 text-white',
                'T-Mobile': 'bg-pink-500 text-white',
                'Plus': 'bg-emerald-500 text-white',
                'other': 'bg-gray-400 text-black'
            };
            return (
                <Tag 
                    id={tooltipId}
                    value={rowData.network} 
                    className={`type-tag ${networkColors[rowData.network]} px-2 py-1 rounded`} 
                />);
        } 
        return null;
    };
    const networkFilterTemplate = (options) => {
        const networkOptions = networks.map(n => ({
            label: n,
            value: n
        }));
        const networkColors = {
            'Orange': 'bg-orange-500 text-white',
            'T-Mobile': 'bg-pink-500 text-white',
            'Plus': 'bg-emerald-500 text-white',
            'other': 'bg-gray-400 text-black'
        };
        return (
            <MultiSelect
                value={options.value}
                options={networkOptions}
                optionLabel="label"
                optionValue="value"
                onChange={(e) => options.filterApplyCallback(e.value)}
                placeholder="Any"
                className="p-column-filter"
                maxSelectedLabels={1}
                style={{ minWidth: '14rem' }}
                itemTemplate={(option) => (
                    <Tag 
                        value={option.label}
                        className={`${networkColors[option.value]} px-2 py-1 rounded`} 
                    />
                )}
            />
        );
    };

    const routerBodyTemplate = (rowData) => {
        if (!rowData.routerSerialNumber) return null;
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.routerSerialNumber}</span>
                <Button
                    icon="pi pi-pencil"
                    rounded
                    text
                    size="small"
                    onClick={() => setEditRouterSerialNumber(rowData.routerSerialNumber)}
                />
            </div>
        );
    };

    const mobileFilterBar = (
        <div className="flex align-items-center gap-2 mb-3">
            <span className="p-input-icon-left flex-1">
                <InputText
                    value={mobileFilters.systemName}
                    onChange={(e) => setMobileFilters(prev => ({ ...prev, systemName: e.target.value }))}
                    placeholder="Search system..."
                    className="w-full"
                />
            </span>
            <div className="relative">
                <Button
                    icon="pi pi-filter"
                    rounded
                    outlined={activeFilterCount === 0}
                    severity={activeFilterCount > 0 ? 'info' : undefined}
                    onClick={openMobileFilterDialog}
                />
                {activeFilterCount > 0 && (
                    <span
                        className="absolute top-0 right-0 bg-primary text-white border-circle flex align-items-center justify-content-center"
                        style={{ width: '1.2rem', height: '1.2rem', fontSize: '0.65rem', transform: 'translate(30%, -30%)' }}
                    >
                        {activeFilterCount}
                    </span>
                )}
            </div>
            <Button icon="pi pi-plus" severity="success" rounded onClick={openNew} />
        </div>
    );

    const cardTemplate = (rowData) => {
        return (
            <div className="col-12">
                {renderMobileNotifications()}
                <div className="border-1 surface-border border-round p-3 mb-2 surface-card">
                    <div className="flex justify-content-between align-items-center pb-2 mb-3 border-bottom-1 surface-border">
                        <span className="font-bold text-lg">{rowData.ID}</span>
                    </div>

                    <div className="mb-2 p-2 surface-50 border-round">
                        <div className="grid">
                            <div className="col-5">
                                <div className="text-xs text-color-secondary">System</div>
                                <div className="font-medium">{rowData.systemName || '---'}</div>
                            </div>
                            <div className="col-2"></div>
                            <div className="col-5">
                                <div className="text-xs text-color-secondary">Node name</div>
                                <div className="font-medium">{rowData.nodeName || '---'}</div>
                            </div>
                            <div className="col-7">
                                <div className="text-xs text-color-secondary">Router</div>
                                <div className="font-medium">{routerBodyTemplate(rowData) || '---'}</div>
                            </div>
                        </div>
                        <div className="grid">
                            <div className="col-5">
                                <div className="text-xs text-color-secondary">IP</div>
                                <div className="font-medium">{rowData.ip || '---'}</div>
                            </div>
                            <div className="col-2"></div>
                            <div className="col-5">
                                <div className="text-xs text-color-secondary">Telephone</div>
                                <div className="font-medium">{rowData.telephone || '---'}</div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-2 p-2 surface-50 border-round">
                        <div className="grid">
                            <div className="col-5">
                                <div className="text-xs text-color-secondary">ICCID</div>
                                <div className="font-medium">{rowData.iccid || '---'}</div>
                            </div>
                            <div className="col-2"></div>
                            <div className="col-5">
                                <div className="text-xs text-color-secondary">Network</div>
                                <div className="font-medium">{networkTemplate(rowData)}</div>
                            </div>
                        </div>
                        <div className="grid">
                            <div className="col-5">
                                <div className="text-xs text-color-secondary">PIN</div>
                                <div className="font-medium">{rowData.pin || '---'}</div>
                            </div>
                            <div className="col-2"></div>
                            <div className="col-5">
                                <div className="text-xs text-color-secondary">PIN Disabled</div>
                                <div className="font-medium">
                                    <Tag
                                        value={rowData.pinDisabled ? 'Yes' : 'No'}
                                        className={`px-2 py-1 rounded ${rowData.pinDisabled ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-3 p-2 surface-50 border-round">
                        <div className="grid">
                            <div className="col-5">
                                <div className="text-xs text-color-secondary">Purpose</div>
                                <div className="font-medium">{rowData.purpose || '---'}</div>
                            </div>
                            <div className="col-2"></div>
                            <div className="col-5">
                                <div className="text-xs text-color-secondary">Owner</div>
                                <div className="font-medium">{rowData.owner || '---'}</div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-3">
                        <div className="text-xs text-color-secondary mb-1">Notes</div>
                        <div className="font-medium">{cleanNotes(rowData.notes)}</div>
                    </div>
                    <div className="flex justify-content-end pt-2 border-top-1 surface-border">
                        {actionBodyTemplate(rowData)}
                    </div>

                </div>
            </div>
        );
    };

    const mobileFilterDialogFooter = (
        <div className="flex justify-content-between">
            <Button label="Reset" icon="pi pi-times" text severity="secondary" onClick={resetMobileFilters} />
            <div className="flex gap-2">
                <Button label="Cancel" icon="pi pi-times" outlined onClick={() => setMobileFilterDialog(false)} />
                <Button label="Apply" icon="pi pi-check" onClick={applyMobileFilters} />
            </div>
        </div>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" rounded outlined className="mr-2" onClick={() => editSimcard(rowData)} />
                <Button icon="pi pi-trash" rounded outlined severity="danger" onClick={() => confirmDeleteSimcard(rowData)} />
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                {/* <Button icon="pi pi-refresh" rounded raised onClick={()=>getSimcards()} /> */}
                <Button label="Export" icon="pi pi-file-export" outlined onClick={() => exportDataTableCsv(dt, 'simcards')} />
            </div>
        );
    };

    const leftToolbarTemplate = () => {
        return (
            <div className="flex flex-wrap gap-2">
                <Button label="New" icon="pi pi-plus" severity="success" onClick={openNew} />
            </div>
        );
    };

    const deleteSimcardDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" outlined onClick={hideDeleteSimcardDialog} />
            <Button label="Yes" icon="pi pi-check" severity="danger" onClick={deleteSimcardItem} />
        </React.Fragment>
    );

    const dataView = useMemo(() => {
        return (
            <div>
                {mobileFilterBar}
                <DataView
                    value={filteredSimcards}
                    itemTemplate={cardTemplate}
                    paginator
                    rows={10}
                />
            </div>
        );
    }, [filteredSimcards, mobileFilters, mobileFilterDialog, createSimcardSuccess, updateSimcardSuccess, updateRouterFail, updateRouterSuccess]);

    const dataTable = useMemo(() => {
        return (
            <div className="card">
                <Toolbar className="mb-4" left={leftToolbarTemplate}  right={rightToolbarTemplate}> </Toolbar>

                <DataTable ref={dt} value={simcards} sortField="ID" sortOrder={-1}
                        dataKey="ID"  paginator rows={25} rowsPerPageOptions={[10, 25, 50, 100]}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} items" globalFilter={globalFilter}
                        filters={filters} onFilter={(e) => setFilters(e.filters)} filterDisplay="row" stripedRows size='small' resizableColumns
                        exportFilename="simcards" exportFunction={(e) => e.field === 'iccid' ? excelTextDataTableCsvValue(e.data) : escapeDataTableCsvValue(e.field === 'notes' ? cleanNotes(e.data) : e.data)} >
                <Column exportable={false}></Column>
                <Column                    
                    field="ID" 
                    header="ID"
                    style={{maxWidth: '45px'}}
                    sortable>
                </Column>
                <Column 
                    field="systemName" 
                    header="System"
                    body={systemNameTemplate}
                    style={{ maxWidth: '180px' }}
                    sortable
                    filter 
                    filterPlaceholder=""
                    showFilterMenu={false}>
                </Column>
                <Column 
                    field="nodeName"
                    header="Node name"
                    body={nodeNameTemplate}
                    style={{ maxWidth: '180px' }}
                    sortable
                    filter 
                    filterPlaceholder=""
                    showFilterMenu={false}>
                </Column>
                <Column
                    field="routerSerialNumber"
                    header="Router"
                    body={routerBodyTemplate}
                    sortable
                    filter
                    filterPlaceholder=""
                    showFilterMenu={false}
                />
                <Column 
                    field="ip" 
                    header="IP"
                    style={{maxWidth:'130px'}}
                    sortable
                    filter 
                    filterPlaceholder=""
                    showFilterMenu={false}>
                </Column>
                <Column 
                    field="telephone" 
                    header="Telephone"
                    style={{maxWidth:'180px'}}
                    sortable
                    filter 
                    filterPlaceholder=""
                    showFilterMenu={false}>               
                </Column>
                <Column 
                    field="purpose" 
                    header="Purpose"
                    style={{maxWidth:'100px'}}
                    sortable
                    filter 
                    showFilterMenu={false}
                    filterElement={enumFilter('purpose', purposes)}
                    > 
                </Column>
                <Column 
                    field="iccid" 
                    header="ICCID"
                    sortable
                    filter 
                    filterPlaceholder=""
                    showFilterMenu={false}>             
                </Column>
                <Column 
                    field="network" 
                    header="Network"
                    style={{maxWidth:'100px'}}
                    filter 
                    sortable
                    showFilterMenu={false}
                    body={networkTemplate}
                    filterElement={networkFilterTemplate}
                    >            
                </Column>
                <Column 
                    field="pin" 
                    header="PIN"
                    style={{maxWidth:'60px'}}
                    sortable>                
                </Column>
                <Column 
                    field="owner" 
                    header="Owner"
                    style={{maxWidth:'100px'}}
                    sortable
                    filter 
                    showFilterMenu={false}
                    filterElement={enumFilter('owner', owners)}
                    >                 
                </Column>
                <Column
                    field="notes"
                    header="Notes"
                    style={{ maxWidth: '80px' }}
                    sortable
                    body={(rowData) => <div>{cleanNotes(rowData.notes)}</div>}
                />
                <Column 
                    field="pinDisabled" 
                    header="PIN disabled"
                    style={{maxWidth:'110px'}}
                    body={(rowData) =>
                        <Tag 
                        value={rowData.pinDisabled ? 'Yes' : 'No'} 
                        className={`px-2 py-1 rounded ${ rowData.pinDisabled ? 'bg-green-500 text-white' : 'bg-red-500 text-white'}`} 
                    />
                    }
                    sortable>                
                </Column>
                <Column body={actionBodyTemplate} exportable={false} style={{ minWidth: '12rem', maxWidth: '24rem' }}></Column>
                </DataTable>
            </div>
        );
    }, [simcards, filters, createSimcardSuccess, updateSimcardSuccess]);


    const renderMobileNotifications = (): JSX.Element => {
        if (!mobileView) return null;
        const failed = updateRouterFail;
        const succeeded = updateRouterSuccess;
        if (failed || succeeded) {
            const headerStyle = failed ? headerStyleFail : headerStyleSuccess;
            const message = failed
                ? 'Saving router failed.'
                : 'Router was saved successfully.';
            return (
                <h5
                    className={updateRouterFail ? 'notification-open-bind-device-fail' : 'notification-open-bind-device-success'}
                    style={headerStyle}
                >
                    {message}
                </h5>
            );
        }
        return null;
    };

    return (
        <div>
            { !!dbSimcards && ( mobileView ? dataView : dataTable) }
            <SimcardEditDialog
                key={selectedSimcard?.ID ?? 'new'}
                visible={simcardDialog}
                initialSimcard={selectedSimcard}
                onHide={() => setSimcardDialog(false)}
            />

            <RouterEditDialog
                key={editRouterSerialNumber ?? 'none'}
                visible={!!editRouterSerialNumber}
                initialRouter={selectedRouterForEdit}
                onHide={() => setEditRouterSerialNumber(null)}
            />

            <Dialog visible={deleteSimcardDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteSimcardDialogFooter} onHide={hideDeleteSimcardDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {simcard && (
                        <span>
                            Are you sure you want to delete this item (#{simcard.ID})?
                        </span>
                    )}
                </div>
            </Dialog>

            <Dialog
                visible={mobileFilterDialog}
                onHide={() => setMobileFilterDialog(false)}
                header="Filter & Sort"
                style={{ width: '95vw' }}
                footer={mobileFilterDialogFooter}
                modal
                className="p-fluid"
            >
                <div className="mb-4">
                    <label className="font-bold mb-2 block">Sort by</label>
                    <div className="flex gap-2">
                        <Dropdown
                            value={pendingSortField}
                            options={sortOptions}
                            onChange={(e) => setPendingSortField(e.value)}
                            className="flex-1"
                        />
                        <Button
                            icon={pendingSortOrder === 1 ? 'pi pi-sort-amount-up' : 'pi pi-sort-amount-down'}
                            outlined
                            onClick={() => setPendingSortOrder(prev => prev === 1 ? -1 : 1)}
                            tooltip={pendingSortOrder === 1 ? 'Ascending' : 'Descending'}
                        />
                    </div>
                </div>

                <div className="mb-3">
                    <label className="text-sm text-color-secondary mb-1 block">Node name</label>
                    <InputText value={pendingFilters.nodeName}
                        onChange={(e) => setPendingFilters(prev => ({ ...prev, nodeName: e.target.value }))}
                        placeholder="Search..." />
                </div>
                <div className="mb-3">
                    <label className="text-sm text-color-secondary mb-1 block">Router</label>
                    <InputText value={pendingFilters.routerSerialNumber}
                        onChange={(e) => setPendingFilters(prev => ({ ...prev, routerSerialNumber: e.target.value }))}
                        placeholder="Search..." />
                </div>
                <div className="mb-3">
                    <label className="text-sm text-color-secondary mb-1 block">IP</label>
                    <InputText value={pendingFilters.ip}
                        onChange={(e) => setPendingFilters(prev => ({ ...prev, ip: e.target.value }))}
                        placeholder="Search..." />
                </div>
                <div className="mb-3">
                    <label className="text-sm text-color-secondary mb-1 block">Telephone</label>
                    <InputText value={pendingFilters.telephone}
                        onChange={(e) => setPendingFilters(prev => ({ ...prev, telephone: e.target.value }))}
                        placeholder="Search..." />
                </div>
                <div className="mb-3">
                    <label className="text-sm text-color-secondary mb-1 block">ICCID</label>
                    <InputText value={pendingFilters.iccid}
                        onChange={(e) => setPendingFilters(prev => ({ ...prev, iccid: e.target.value }))}
                        placeholder="Search..." />
                </div>
                <div className="mb-3">
                    <label className="text-sm text-color-secondary mb-1 block">Network</label>
                    <MultiSelect
                        value={pendingFilters.network}
                        options={networks.map(n => ({ label: n, value: n }))}
                        onChange={(e) => setPendingFilters(prev => ({ ...prev, network: e.value }))}
                        placeholder="Any"
                        className="w-full"
                        maxSelectedLabels={2}
                        itemTemplate={(option) => (
                            <Tag value={option.label} className={`${networkColors[option.value]} px-2 py-1 rounded`} />
                        )}
                    />
                </div>
                <div className="mb-3">
                    <label className="text-sm text-color-secondary mb-1 block">Purpose</label>
                    <Dropdown value={pendingFilters.purpose} options={purposes}
                        onChange={(e) => setPendingFilters(prev => ({ ...prev, purpose: e.value }))}
                        placeholder="Any" showClear className="w-full" />
                </div>
                <div className="mb-3">
                    <label className="text-sm text-color-secondary mb-1 block">Owner</label>
                    <Dropdown value={pendingFilters.owner} options={owners}
                        onChange={(e) => setPendingFilters(prev => ({ ...prev, owner: e.value }))}
                        placeholder="Any" showClear className="w-full" />
                </div>
                <div className="mb-3">
                    <label className="text-sm text-color-secondary mb-1 block">PIN Disabled</label>
                    <Dropdown
                        value={pendingFilters.pinDisabled}
                        options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}
                        onChange={(e) => setPendingFilters(prev => ({ ...prev, pinDisabled: e.value }))}
                        placeholder="Any" showClear className="w-full" />
                </div>
            </Dialog>

            <Snackbar
                close
                closeNotification={() => closeUpdateSimcardSuccessNotification()}
                color='success'
                message={'SIM card updated'}
                open={!mobileView && updateSimcardSuccess}
                place='tc'
            />
            <Snackbar
                close
                closeNotification={() => closeUpdateSimcardFailNotification()}
                color='danger'
                message={updateSimcardFailMessage || 'Update error'}
                open={!mobileView && updateSimcardFail}
                place='tc'
            />
            <Snackbar
                close
                closeNotification={() => closeCreateSimcardSuccessNotification()}
                color='success'
                message={'SIM card created'}
                open={!mobileView && createSimcardSuccess}
                place='tc'
            />
            <Snackbar
                close
                closeNotification={() => closeCreateSimcardFailNotification()}
                color='danger'
                message={createSimcardFailMessage || 'Create error'}
                open={!mobileView && createSimcardFail}
                place='tc'
            />
            <Snackbar
                close
                closeNotification={closeNotification}
                color={updateRouterFail ? 'danger' : 'success'}
                message={updateRouterFail
                    ? 'Saving router failed.'
                    : 'Router was saved successfully.'
                }
                open={!mobileView && (updateRouterFail || updateRouterSuccess)}
                place='tc'
            />
        </div>
    );
}


const mapStateToProps = (state) => {
    return {
        mobileView: state.dashboard.mobileView,
        dbSimcards: state.dashboard.simcards,
        dbRouters: state.dashboard.routers,
        currentSimcard: state.dashboard.currentSimcard,
        updateSimcardSuccess: state.dashboard.updateSimcardSuccess,
        updateSimcardFail: state.dashboard.updateSimcardFail,
        updateSimcardFailMessage: state.dashboard.updateSimcardFailMessage,
        createSimcardSuccess: state.dashboard.createSimcardSuccess,
        createSimcardFail: state.dashboard.createSimcardFail,
        createSimcardFailMessage: state.dashboard.createSimcardFailMessage,
        updateRouterSuccess: state.dashboard.updateRouterSuccess,
        updateRouterFail: state.dashboard.updateRouterFail,
    };
};

const actions = {
    getSystemsVeryShort,
    getSystemsNodesShort,
    getSystemsNodesRoutersShort,
    getSimcards,
    getRouters,
    updateSimcard,
    addSimcard,
    getSimcard,
    deleteSimcard,
    closeUpdateSimcardSuccessNotification,
    closeUpdateSimcardFailNotification,
    closeCreateSimcardSuccessNotification,
    closeCreateSimcardFailNotification
};

export default connect(mapStateToProps, actions)(Simcards);
